import styled from 'styled-components';
import { ImageUtils } from '../../../../utils/ImageUtils';
import { BottomSns } from '../../../common/BottomSnsImg';
import { useTextVariant } from '../../../../hook/useTextVariant';
import { REWARD_INFO_CONSTANTS } from '../../../../constants/rewardInfo';

export const RewardInfoMobile = () => {
  const { getText } = useTextVariant(REWARD_INFO_CONSTANTS, true);

  return (
    <>
      <Wrap>
        <LabelRed>
          <LabelText>{getText('onlineSatelliteTitle')}</LabelText>
        </LabelRed>
        <CongressContainer>
          <TopDateText>{getText('onlineDate')}</TopDateText>
          <Divider />
          <CongressLocation>
            <AppContainer>
              <img src={ImageUtils.ShowDownApp} alt="" />
              {getText('appDesc')}
            </AppContainer>
          </CongressLocation>
        </CongressContainer>
        <LabelBlue>
          <LabelText>{getText('offlineEventTitle')}</LabelText>
        </LabelBlue>

        <CongressOfflineContainer>
          <DayContainer>
            <BottomDateText>{getText('offlineDate')}</BottomDateText>
          </DayContainer>
          <FullText>{getText('fullEventName')}</FullText>
          <LocationContainer>
            <CircleLocation>{getText('venue')}</CircleLocation>
            <LocationText>{getText('venueAddress')}</LocationText>
          </LocationContainer>
        </CongressOfflineContainer>

        <PartnerWrap>
          <PartnerContainer>
            <PartnerTitle>{getText('partnerTitle')}</PartnerTitle>
            <PartnerContent>
              <img src={ImageUtils.PartnerIcon} alt="" />
            </PartnerContent>
          </PartnerContainer>

          <RequestKakaoContainer>
            <RequestText>{getText('requestText')}</RequestText>
            <img src={ImageUtils.KakaoIcon} alt="" />
          </RequestKakaoContainer>
        </PartnerWrap>
      </Wrap>
      <BottomSns />
    </>
  );
};

const RequestKakaoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #222;
  flex: 1;
  border-top: 1px solid rgba(0, 0, 0, 0.5);
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);
  height: 94px;
  img {
    width: 40px;
  }
`;

const RequestText = styled.p`
  text-align: left;
  font-size: 13px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  margin-right: 20px;

  span {
    color: #fae100;
    font-weight: 500;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: 6%;
    text-underline-offset: 20%;
    cursor: pointer;
  }
`;

const DayContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  img {
    width: 12px;
  }
`;

const FullText = styled.h3`
  color: #3fb5ff;
  font-weight: 600;
  letter-spacing: -1.04px;
  text-align: left;
  font-size: 16px;
  line-height: 18px;
  margin-bottom: 10px;
  margin-top: 6px;
`;

const LocationContainer = styled.div`
  display: flex;
  align-items: center;
`;

const CircleLocation = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  letter-spacing: -0.88px;
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: rgba(0, 0, 0, 0);
  text-align: center;
  flex-shrink: 0;

  font-size: 12px;
  line-height: 22px;
  padding-left: 20px;
  padding-right: 20px;

  margin-right: 4px;
  height: 24px;
`;

const LocationText = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
  letter-spacing: -0.96px;
  text-align: left;
  font-size: 14px;
  line-height: 18px;

  display: flex;
  align-items: center;
  img {
    margin-right: 4px;
  }
`;

const Wrap = styled.div`
  padding-bottom: 170px;
  text-align: center;
  padding-top: 13px;
  padding-right: 5px;
  padding-left: 5px;
`;

const Label = styled.div`
  width: 100%;
  height: 24px;
`;

const LabelRed = styled(Label)`
  margin-top: 0;
  border-top: 2px solid #d92a76;
  border-bottom: 1px solid #d92a76;
  background: linear-gradient(90deg, rgba(201, 0, 80, 0.7) 25.71%, rgba(164, 0, 71, 0.7) 86.89%);
`;

const LabelBlue = styled(Label)`
  border-top: 2px solid #1e95f6;
  border-bottom: 1px solid #1e95f6;
  background: linear-gradient(91deg, rgba(0, 155, 251, 0.8) 10.71%, rgba(0, 114, 207, 0.8) 84.3%);
`;

const LabelText = styled.p`
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  font-size: 15px;
  line-height: 20px;
`;

const CongressContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #222;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 10px;
  height: 101px;
`;

const CongressOfflineContainer = styled(CongressContainer)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background-color: #222;
  height: auto;
  padding-top: 11px;
  padding-bottom: 10px;
  margin-bottom: 2px;
  padding-left: 10px;
  padding-right: 10px;
`;

const TopDateText = styled.h4`
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
  text-align: left;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.64px;

  span {
    color: rgba(255, 255, 255, 0.6);
    font-size: 14px;
    line-height: 22px;
  }
`;

const BottomDateText = styled(TopDateText)``;

const Divider = styled.div`
  height: 70%;
  width: 1px;
  background: rgba(217, 217, 217, 0.2);
`;

const CongressLocation = styled.h4`
  width: 50%;
  color: rgba(255, 255, 255, 0.6);
  text-align: right;
  font-weight: 500;
  letter-spacing: -0.88px;

  @media screen and (max-width: 500px) {
    width: auto;
  }
`;

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 16px;

  img {
    width: 40px;
    margin-bottom: 8px;
  }
`;

const PartnerWrap = styled.div`
  display: flex;
`;

const PartnerContainer = styled.div`
  width: 136px;
  margin-right: 3px;
  margin-bottom: 2px;
  &:last-child {
    margin-right: 0;
  }
`;

const PartnerTitle = styled.h3`
  font-size: 12px;
  line-height: 25px;
  height: 25px;
  border-bottom: 1px solid #000000;
  background: rgba(0, 0, 0, 0.5);
  font-family: 'Gmarket';
  color: rgba(255, 255, 255, 0.5);
  text-align: center;
  font-weight: 500;
  letter-spacing: -0.8px;
`;

const PartnerContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  height: 69px;

  img {
    width: 69px;
  }
`;
